<template>
  <div class="app-footer">
    <!-- <div class="youtu-other">
      <div class="youtu-other-container">
        <div class="youtu-other-item">
          <div class="youtu-other-icon sy"></div>
          <div class="youtu-other-content">
            <div class="youtu-other-title">产品试用</div>
            <div class="youtu-other-info">填写此简短表格，我们将尽快联系您！</div>
          </div>
          <div class="youtu-other-detail" @click="handleJumpPage('https://ai.qq.com/contact/?from=youtu')">
            立即申请
          </div>
        </div>
        <div class="youtu-other-item">
          <div class="youtu-other-icon swlx"></div>
          <div class="youtu-other-content">
            <div class="youtu-other-title">商务合作</div>
            <div class="youtu-other-info">youtu@tencent.com</div>
          </div>
          <div class="youtu-other-detail">
            <a href="mailto:youtu@tencent.com?subject=商务合作">联系我们</a>
          </div>
        </div>
      </div>
    </div> -->
    <div class="youtu-other-container" v-if="!$route.meta.isAboutusFormActive">
      <div class="youtu-other">
        <div class="youtu-other-item">
          <div class="youtu-other-icon sy"></div>
          <div class="youtu-other-content">
            <div class="youtu-other-title">产品试用</div>
            <div class="youtu-other-info">填写此简短表格，我们将尽快联系您！</div>
            <!-- <div class="youtu-other-more" @click="handleJumpPage('https://ai.qq.com/contact/?from=youtu')">把您需求发给我们</div> -->
            <div class="youtu-other-more" @click="handleJumpPage('OPEN_ABOUTUS_CONTACTUS')">把您需求发给我们</div>
          </div>
        </div>
        <div class="youtu-other-item">
          <div class="youtu-other-icon swlx"></div>
          <div class="youtu-other-content">
            <div class="youtu-other-title">商务合作</div>
            <div class="youtu-other-info">
              <a href="mailto:youtu@tencent.com?subject=商务合作">邮箱地址：youtu@tencent.com</a>
            </div>
          </div>
        </div>
        <div class="youtu-other-item">
          <div class="youtu-other-icon hzhb"></div>
          <div class="youtu-other-content">
            <div class="youtu-other-title">生态伙伴招募</div>
            <div class="youtu-other-info hzhb-info" @click="handleJumpPage('OPEN_ABOUTUS_PARTNER')">成为合作伙伴</div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-footer-container">
      <div class="app-footer-map">
        <div class="map">
          <div class="map-title">站点地图</div>
          <div class="map-content">
            <div class="map-content-item" v-for="(val, index) in mapContent" :key="index" @click="handleJumpPage(val.url, val.key)">
              {{val.title}}
            </div>
          </div>
        </div>
        <div class="concat">
          <div class="concat-title">关注或联系我们</div>
          <div class="concat-info">扫码添加腾讯优图公众号，获取更多AI前沿技术信息</div>
          <div class="concat-img-container">
            <div class="concat-img-item">
              <div class="concat-img img-gzh"></div>
              <div class="concat-img-title">优图公众号</div>
            </div>
            <div class="concat-img-item">
              <div class="concat-img img-xzs"></div>
              <div class="concat-img-title">优图小助手</div>
            </div>
            <div class="concat-img-item">
              <div class="concat-img img-sph"></div>
              <div class="concat-img-title">优图视频号</div>
            </div>
          </div>
          <div class="concat-info">企业邮箱：youtu@tencent.com</div>
        </div>
      </div>
      <div class="app-footer-right">
        <div class="app-footer-right-left">
          <div class="app-footer-right-title">腾讯优图，你身边的视觉AI专家</div>
        </div>
        <div class="app-footer-right-text">Copyright © 1998-{{(new Date()).getFullYear()}} Tencent. All Rights Reserved.</div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteKey from '@/common/RouteKey';
/* {
  title: '核心技术',
  url: ''
}, {
  title: '产品服务',
  url: ''
}, */
const mapContent = [{
  title: '客户案例',
  url: 'OPEN_COOPERATION'
}, {
  title: '新闻中心',
  url: 'OPEN_NEWSCENTER'
}, {
  title: '学术研究',
  url: 'OPEN_ACADEMIC_RESEARCH'
}, {
  title: '关于优图',
  url: 'OPEN_ABOUTUS_INTRO'
}, {
  title: '加入我们',
  url: 'OPEN_ABOUTUS_INTRO',
  key: 'joinus'
}, {
  title: '产品试用',
  url: 'OPEN_ABOUTUS_CONTACTUS'
}, {
  title: '商务合作',
  url: 'mailto:youtu@tencent.com?subject=商务合作'
}, {
  title: '生态伙伴招募',
  url: 'OPEN_ABOUTUS_PARTNER'
}];
export default {
  name: 'AppFooter',
  data() {
    return {
      mapContent
    };
  },
  methods: {
    handleJumpPage(url, key) {
      if (url.indexOf('http') !== -1) {
        window.open(url, '_blank');
        return;
      }
      if (url.indexOf('mailto') !== -1) {
        window.open(url, '_self');
        return;
      }
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, {key: key});
        return;
      }
      this.$router.transfer(url);
    }
  }
};
</script>

<style lang="less" scoped>
  .app-footer {
    width: 100%;
    background-color: #000000;
    background: #F4F7FA;
    .youtu-other-container {
      width: 100%;
      height: 228px;
      background: url('./img/other/bg_cpsy.jpg') center center no-repeat;
      background-size: cover;
      .youtu-other {
        width: 1263px;
        margin: 0 auto;
        padding: 38px 30px;
        box-sizing: border-box;
        font-size: 0;
        .youtu-other-item {
          width: 400px;
          display: inline-block;
          vertical-align: top;
          position: relative;
          .youtu-other-icon {
            width: 50px;
            height: 50px;
            position: absolute;
            top: 24px;
            left: 0;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            image-rendering: -webkit-optimize-contrast;
          }
          .sy {
            background-image: url("./img/other/icon_sy.png");
          }
          .swlx {
            background-image: url("./img/other/icon_cwlx.png");
          }
          .hzhb {
            background-image: url("./img/other/icon_hzhb.png");
          }
          .youtu-other-content {
            margin-left: 94px;
            margin-top: 24px;
            color: #FFFFFF;
            .youtu-other-title{
              height: 28px;
              font-family: 'PingFangSC-Semibold';
              font-size: 20px;
              font-weight: 600;
            }
            .youtu-other-info {
              height: 20px;
              width: 255px;
              letter-spacing: 1px;
              font-size: 14px;
              margin-top: 10px;
              &.hzhb-info {
                width: 120px;
                background: url("./img/arrow_white.svg") center right no-repeat;
                &:hover {
                  cursor: pointer;
                  color: #0080FF;
                  background: url("./img/arrow_normal.svg") center right no-repeat;
                }
              }
              a {
                text-decoration: none;
                color: #ffffff;
                &:hover {
                  color: #0080FF;
                }
              }
            }
            .youtu-other-more {
              height: 20px;
              width: 142px;
              font-size: 14px;
              background: url("./img/arrow_white.svg") center right no-repeat;
              margin-top: 30px;
              &:hover {
                cursor: pointer;
                color: #0080FF;
                background: url("./img/arrow_normal.svg") center right no-repeat;
              }
            }
          }
        }
        
      }
    }
    /* .youtu-other {
      width: 100%;
      height: 300px;
      background-image: url('./img/other/bg_cpsy.png');
      background-size: cover;
      background-repeat: no-repeat;
      .youtu-other-container {
        width: 1263px;
        margin: 0 auto;
        color: #ffffff;
        display: flex;
        justify-content: flex-end;
        padding: 0 20px;
        .youtu-other-item {
          width: 380px;
          height: 178px;
          margin: 60px 10px 0;
          background: #222832;
          box-shadow: 0px 4px 20px 0px rgba(36,41,51,0.5);
          box-shadow: -8px -8px 20px 0px rgba(54,62,77,0.45);
          box-shadow: 8px 8px 20px 0px rgba(18,21,26,0.65);
          position: relative;
          .youtu-other-icon {
            width: 50px;
            height: 50px;
            position: absolute;
            top: 24px;
            left: 24px;
          }
          .sy {
            background-image: url("./img/other/icon_sy.png");
          }
          .swlx {
            background-image: url("./img/other/icon_swlx.png");
          }
          .youtu-other-content {
            margin-left: 94px;
            margin-top: 24px;
            .youtu-other-title{
              height: 28px;
              font-family: 'PingFangSC-Semibold';
              font-size: 20px;
              font-weight: 600;
            }
            .youtu-other-info {
              height: 20px;
              opacity: 0.8;
              letter-spacing: 1px;
              font-size: 14px;
              margin-top: 10px;
            }
          }
          .youtu-other-detail {
            width: 121px;
            background: url("./img/arrow_white.png") 86px center no-repeat, #0080FF;
            position: absolute;
            bottom: 30px;
            left: 95px;
            font-family: 'PingFangSC-Semibold';
            font-size: 14px;
            font-weight: 600;
            height: 36px;
            line-height: 36px;
            padding-left: 20px;
            a {
              text-decoration: none;
              color: #ffffff;
            }
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    } */
    .app-footer-container {
      width: 1263px;
      margin: 0 auto;
      background-color: #F4F7FA;
      color: #3D485D;
      .app-footer-map {
        margin: 0 30px;
        height: 250px;
        display: flex;
        justify-content: space-between;
        .map {
          flex: 1;
          .map-title {
            height: 24px;
            font-family: "PingFangSC-Medium";
            font-size: 14px;
            color: #3D485D;
            line-height: 24px;
            font-weight: 500;
            margin-top: 50px;
          }
          .map-content {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            width: 80%;
            margin-top: 10px;
            .map-content-item {
              width: 12%;
              height: 24px;
              color: #3D485D;
              opacity: 0.8;
              font-size: 12px;
              line-height: 24px;
              margin-top: 10px;
              &:hover {
                cursor: pointer;
                color: #0080FF;
                opacity: 1;
              }
            }
          }
        }
        .concat {
          width: 280px;
          .concat-title {
            height: 24px;
            font-family: "PingFangSC-Semibold";
            font-size: 14px;
            line-height: 24px;
            font-weight: 600;
            margin: 50px 0 10px;
          }
          .concat-info {
            opacity: 0.8;
            font-size: 12px;
          }
          .concat-img-container {
            margin: 10px 0;
            display: flex;
            justify-content: space-between;
            .concat-img-item {
              .concat-img {
                width: 70px;
                height: 70px;
                box-shadow: 5px 5px 10px 0 rgba(55,99,170,0.10);
                image-rendering: -webkit-optimize-contrast;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
              }
              .img-gzh {
                background-image: url('./img/openhomefooter/img_qr_gzh.jpg');
              }
              .img-xzs {
                background-image: url('./img/openhomefooter/img_qr_xzs.jpg');
              }
              .img-sph {
                background-image: url('./img/openhomefooter/img_qr_sph.jpg');
              }
              .concat-img-title {
                opacity: 0.8;
                font-size: 12px;
                text-align: center;
                margin-top: 6px;
              }
            }
          }
        }
      }
      .app-footer-right {
        margin: 0 30px;
        height: 50px;
        font-size: 12px;
        position: relative;
        border-top: 1px solid #D2D7DF;
        padding-top: 20px;
        .app-footer-right-left {
          background: url("./img/logo_youtu.svg") top left no-repeat;
          background-size: 70px 20px;
          .app-footer-right-title {
            display: inline-block;
            margin-left: 80px;
            letter-spacing: 6px;
            text-align: justify;
            line-height: 20px;
            padding-left: 10px;
            border-left: 1px solid #D2D7DF;
          }
        }
        .app-footer-right-text {
            height: 20px;
            text-align: center;
            line-height: 20px;
            position: absolute;
            right: 0;
            top: 20px;
        }
      }
    }
    @media screen and (-Webkit-min-device-pixel-ratio: 2),
    screen and (-moz-min-device-pixel-ratio: 2),
    screen and (-o-min-device-pixel-ratio: 2),
    screen and (min-device-pixel-ratio: 2) {
      .youtu-other-container .youtu-other{
        .youtu-other-item {
          .sy {
            background-image: url("./img/other/icon_sy_2x.png");
          }
          .swlx {
            background-image: url("./img/other/icon_cwlx_2x.png");
          }
          .hzhb {
            background-image: url("./img/other/icon_hzhb_2x.png");
          }
        }
      }
      .app-footer-container .app-footer-map{
        .concat {
          .concat-img-container {
            .concat-img-item {
              .img-gzh {
                background-image: url('./img/openhomefooter/img_qr_gzh_2x.jpg');
              }
              .img-xzs {
                background-image: url('./img/openhomefooter/img_qr_xzs_2x.jpg');
              }
              .img-sph {
                background-image: url('./img/openhomefooter/img_qr_sph_2x.jpg');
              }
            }
          }
        }
      }
    }
    @media (min-width: 1600px) {
      .youtu-other-container .youtu-other{
        .youtu-other-item {
          .sy {
            background-image: url("./img/other/icon_sy_2x.png");
          }
          .swlx {
            background-image: url("./img/other/icon_cwlx_2x.png");
          }
          .hzhb {
            background-image: url("./img/other/icon_hzhb_2x.png");
          }
        }
      }
      .app-footer-container .app-footer-map{
        .concat {
          .concat-img-container {
            .concat-img-item {
              .img-gzh {
                background-image: url('./img/openhomefooter/img_qr_gzh_2x.jpg');
              }
              .img-xzs {
                background-image: url('./img/openhomefooter/img_qr_xzs_2x.jpg');
              }
              .img-sph {
                background-image: url('./img/openhomefooter/img_qr_sph_2x.jpg');
              }
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/open/common/AppFooter.vue